import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("tmo_user") || "null"); }
    catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u) => {
    localStorage.setItem("tmo_token", token);
    localStorage.setItem("tmo_user", JSON.stringify(u));
    setUser(u);
  };

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    persist(data.access_token, data.user);
    return data.user;
  }, []);

  const register = useCallback(async (full_name, email, password, role = "student") => {
    const { data } = await api.post("/api/auth/register", { full_name, email, password, role });
    persist(data.access_token, data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("tmo_token");
    localStorage.removeItem("tmo_user");
    setUser(null);
  }, []);

  // refresh user once on mount if token exists
  useEffect(() => {
    const token = localStorage.getItem("tmo_token");
    if (token && !user) {
      setLoading(true);
      api.get("/api/auth/me").then(({ data }) => {
        localStorage.setItem("tmo_user", JSON.stringify(data));
        setUser(data);
      }).catch(() => {}).finally(() => setLoading(false));
    }
    // intentionally only on mount — including `user` would cause a refetch loop
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, register, logout }),
    [user, loading, login, register, logout],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
